function docReady(fn) {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(fn, 1)
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}

const priceFormat =
  shopCurrencySymbol !== '£' && shopCurrencySymbol !== '$' ? '{{ amount_with_comma_separator }}' : '{{ amount }}'

docReady(function () {
  renderCartSide()

  /* Terms and Condictions cart checkox */
  const addCheckboxTermsListener = (selector, event, handler) => {
    let rootElement = document.querySelector('#sideCart')
    rootElement.addEventListener(
      event,
      function (evt) {
        var targetElement = evt.target
        while (targetElement != null) {
          if (targetElement.matches(selector)) {
            handler(evt)
            return
          }
          targetElement = targetElement.parentElement
        }
      },
      true
    )
  }

  const checkTermsCheckbox = e => {
    const checkoutForm = e.target.closest('form')

    const termsInput = checkoutForm.querySelector('#terms-check')

    if (!termsInput.checked) {
      alert(cartTranslations.termsNotify)
      e.stopPropagation()
      e.preventDefault()
      return
    }
  }

  const logUserCheck = e => {
    const checkoutForm = e.target.closest('form')
    const termsInput = checkoutForm.querySelector('#terms-check')

    const termsRecordInput = checkoutForm.querySelector('#agreed-to-the-terms-and-conditions-on')
    termsRecordInput.value = termsInput.checked ? new Date() : ''
  }

  const isCartVisible = document.querySelector('[data-section-type="cart"]')
  const bottone = document.querySelectorAll('button[name=checkout]')
  console.log('✨🐉✨ ~ file: cartSide.js:499 ~ addCompareAtPrice ~ bottone:', bottone)

  if (isCartVisible) {
    addCheckboxTermsListener('button[name=checkout]', 'click', checkTermsCheckbox)
    addCheckboxTermsListener('[data-role="cart-terms-checkbox"]', 'click', logUserCheck)
  }
})

function renderCartSide() {
  getCartItems()
  let targetNode = document.querySelector('.cart__checkout__container')
  const config = { attributes: true, childList: true, subtree: true }
  const callback = function (mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        let targetLabel = document.querySelector('.cart__checkout__container p label')
        if (targetLabel) {
          observer.disconnect()
          targetLabel.innerHTML = `${cartTranslations.termsConditionsPrefix} <a class='underline' href='/pages/terms-conditions'>${cartTranslations.termsConditionsSuffix} </a>`
        }
      } else if (mutation.type === 'attributes') {
      }
    }
  }

  let observer = null
  observer = new MutationObserver(callback)
  observer.observe(targetNode, config)

  if (window.innerWidth >= 768) {
    // Apro il menù al click sull'icona carrello
    document.getElementById('cart-icon').addEventListener('click', openCartSide)

    document.getElementById('overlay-cart').addEventListener('click', e => closeCartSide())
    // Chiudo lo slide su
    // document.addEventListener(
    //   "click",
    //   function (e) {
    //     if (
    //       event.target.matches("#closeSideCart") ||
    //       (document.getElementById("cart-side-modal").style.display ===
    //         "block" &&
    //         !event.target.closest("#cart-side-modal"))
    //     ) {
    //       // closeCartSide();
    //     }
    //   },
    //   false
    // );

    document.getElementById('closeSideCart').addEventListener('click', closeCartSide)
  } else {
    document.getElementById('cart-icon').addEventListener('click', () => (window.location.href = routesObject.cart_url))
  }
}

// Funzione apertura carrello
async function openCartSide() {
  let sideCartItems = Array.from(document.querySelectorAll('.sideCart_item'))

  var tl = gsap.timeline()

  let headerHeight = document.getElementById('megamenu_container').offsetHeight

  let cartIconElementBoundingRect = document.getElementById('cart-icon').getBoundingClientRect()
  document.body.style.overflow = 'hidden'
  document.getElementById('overlay-cart').style.display = 'block'

  let cartSideModal = document.getElementById('cart-side-modal')
  cartSideModal.style.display = 'block'
  // cartSideModal.style.top = `${
  //   cartIconElementBoundingRect.top + cartIconElementBoundingRect.height
  // }px`;

  // cartSideModal.style.height = `${
  //   window.innerHeight -
  //   (cartIconElementBoundingRect.top + cartIconElementBoundingRect.height)
  // }px`;

  cartSideModal.style.top = '0px'
  cartSideModal.style.height = '100vh'

  let sideCart = document.getElementById('sideCart')
  // sideCart.style.height = `${
  //   window.innerHeight -
  //   (cartIconElementBoundingRect.top + cartIconElementBoundingRect.height) -
  //   100
  // }px`;
  sideCart.style.height = '100%'

  // Animazione laterale slide
  tl.to('#cart-side-wrapper', { duration: 0.5, x: -548 })
}

// Funzione chiusura carrello
function closeCartSide() {
  // Chiusura laterale slide
  var tl = gsap.timeline()
  tl.to('#cart-side-wrapper', {
    duration: 0.5,
    x: 0,
    onComplete: () => {
      document.getElementById('cart-side-modal').style.display = 'none'
      document.getElementById('overlay-cart').style.display = 'none'
      document.body.style.overflow = 'auto'
    },
  })
}

const getFullPrice = async item => {
  console.log('getFullPrice for')
  console.log(item)
  const variant = await fetch(`/products/${item.handle}.js`)
    .then(resp => resp.json())
    .then(data => {
      return data.variants.filter(variant => variant.id === item.variant_id)[0]
    })
  return variant.compare_at_price
}

const renderItemPrice = (currentPrice, fullPrice, itemsQuantity = 1) => {
  let price = ''

  if (fullPrice && fullPrice !== currentPrice) {
    const discount = 100 - (currentPrice * 100) / fullPrice
    price = `<div><span class="line-through mr-2">
    ${Shopify.formatMoney(itemsQuantity * fullPrice, shopCurrencySymbol + priceFormat)}    
    </span><span class="inline-block "> - ${Math.round(discount)}%</div> <div class="text-wp-red inline-block ml-2">
    ${Shopify.formatMoney(itemsQuantity * currentPrice, shopCurrencySymbol + priceFormat)}
    </span></div>`
  } else {
    price = Shopify.formatMoney(itemsQuantity * currentPrice, shopCurrencySymbol + priceFormat)
  }

  return price
}

async function getCartItems() {
  const cart = await fetch('/cart.js')
    .then(response => response.json())
    .then(data => data)
  const cartItems = await addCompareAtPrice(cart)
  // console.log('getCartItems!')
  // console.log(cartItems)

  if (cartItems) {
    let sideCartItemList = document.getElementById('sideCart_itemsList')
    let sideCartWrapper = document.getElementById('cart-side-wrapper')

    // sideCartItemList.height = `${(window.innerHEight / 100) * 70}px`;
    sideCartItemList.innerHTML = ''
    Array.from(document.querySelectorAll('#cart-subtotal span, #cart-total span')).forEach(item => {
      item.innerHTML = Shopify.formatMoney(cartItems.total_price, shopCurrencySymbol + priceFormat)
    })
    cartItems.items.forEach(async item => {
      // item.compare_at_price = await getFullPrice(item)
      let itemPrice = String(item.price)

      let cartItemWrapper = document.createElement('div')
      cartItemWrapper.className =
        'sideCart_item border-b border-dirty-gray flex justify-start w-full content-center py-5'
      cartItemWrapper.setAttribute('id', `sideCart-item-${item.variant_id}`)
      //CREO SLOT FOTO
      let cartImgElement = document.createElement('img')
      cartImgElement.className = 'w-full object-cover object-center'
      cartImgElement.setAttribute('src', item.featured_image.url)
      cartImgElement.setAttribute('alt', item.handle)

      let cartAnchorElement = document.createElement('a')
      cartAnchorElement.className = 'cart-img-wrapper block w-1/4 overflow-y-hidden mr-3 sideCart_item__img'
      cartAnchorElement.setAttribute('href', item.url)
      cartAnchorElement.appendChild(cartImgElement)

      //CREO SLOT INFO
      let cartVendorElement = document.createElement('div')
      cartVendorElement.className = 'text-base mb-1'
      cartVendorElement.innerHTML = item.vendor

      let cartTitleElement = document.createElement('div')
      cartTitleElement.className = 'cart__textProductTitle text-xs mb-1'
      cartTitleElement.innerHTML = item.product_title

      let cartSkuElement = document.createElement('div')
      cartSkuElement.className = 'text-xs mb-1'
      cartSkuElement.innerHTML = `${cartTranslations.code}: ` + item.sku

      // let cartColorElement = document.createElement('div')
      // cartColorElement.className = 'text-xs mb-1'
      // cartColorElement.innerHTML = `${cartTranslations.color}: ` + item.variant_options[1]

      let cartPriceElement = document.createElement('div')
      cartPriceElement.className = 'text-xs mb-1'
      cartPriceElement.innerHTML =
        `${cartTranslations.price}: ` + Shopify.formatMoney(itemPrice, shopCurrencySymbol + priceFormat)
      const cartDiscountElement = document.createElement('div')
      cartPriceElement.className = 'text-xs mb-1'

      let cartInfoWrapper = document.createElement('div')
      cartInfoWrapper.className = 'flex flex-col justify-between sideCart_item__info'
      cartInfoWrapper.appendChild(cartVendorElement)
      cartInfoWrapper.appendChild(cartTitleElement)
      cartInfoWrapper.appendChild(cartSkuElement)
      // cartInfoWrapper.appendChild(cartVariantTitleElement)
      // cartInfoWrapper.appendChild(cartColorElement)
      cartInfoWrapper.appendChild(cartPriceElement)

      //CREO SLOT UTILITIES

      let cartUtilsWrapper = document.createElement('div')
      cartUtilsWrapper.className = 'flex flex-col text-right justify-between sideCart_item__price'

      //SEZIONE ICONE
      let cartUtilsIconsWrapper = document.createElement('div')
      cartUtilsIconsWrapper.className = 'icons-cart flex justify-end items-center content-center'

      // let cartUtilsWishlistIcon = document.createElement("img");
      // cartUtilsWishlistIcon.className =
      //   "w-5 h-auto text-base cursor-pointer pointer-events-none";
      // cartUtilsWishlistIcon.setAttribute("data-id", item.variant_id);

      // let wishlist = localStorage.getItem('wpWishlistItems')
      // wishlist = JSON.parse(wishlist)
      // let isItemInWishlist = null
      // if (wishlist) {
      //   isItemInWishlist = wishlist.find(wishlistItem => wishlistItem.id == item.variant_id)
      // }

      // if (isItemInWishlist) {
      //   cartUtilsWishlistIcon.setAttribute(
      //     'src',
      //     'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addedToWishlist.svg?v=1625557378'
      //   )
      // } else {
      //   cartUtilsWishlistIcon.setAttribute(
      //     'src',
      //     'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addToWishlist.svg?v=1625557378'
      //   )
      // }

      // let cartUtilsWishlistWrapper = document.createElement("div");
      // cartUtilsWishlistWrapper.className = "mr-1 inline-block cursor-pointer";
      // cartUtilsWishlistWrapper.setAttribute("data-id", item.variant_id);
      // cartUtilsWishlistWrapper.setAttribute("data-handle", item.handle);
      // cartUtilsWishlistWrapper.appendChild(cartUtilsWishlistIcon);
      // cartUtilsWishlistWrapper.addEventListener("click", e =>
      //   wishlistManagement(e)
      // );

      let cartRemotionIcon = document.createElement('img')
      cartRemotionIcon.className = 'pointer-events-none w-5 h-auto text-base'
      cartRemotionIcon.setAttribute(
        'src',
        'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/trash.svg?v=1628455844'
      )

      let cartUtilsRemotionWrapper = document.createElement('div')
      cartUtilsRemotionWrapper.className = 'mr-1 inline-block cursor-pointer'
      cartUtilsRemotionWrapper.setAttribute('data-id', item.variant_id)
      cartUtilsRemotionWrapper.appendChild(cartRemotionIcon)
      cartUtilsRemotionWrapper.addEventListener('click', e => changeCartQuantity(e, 'decrease', true))

      // cartUtilsIconsWrapper.appendChild(cartUtilsWishlistWrapper);
      cartUtilsIconsWrapper.appendChild(cartUtilsRemotionWrapper)

      //SEZIONE QUANTITA
      let cartUtilsQuantityLabel = document.createElement('div')
      cartUtilsQuantityLabel.className = 'text-xs uppercase mt-3 sm:mt-0 sm:text-center md:text-right'
      cartUtilsQuantityLabel.innerHTML = '<div>' + cartTranslations.quantity + '</div>'

      let cartUtilsDecreaseElement = document.createElement('div')
      cartUtilsDecreaseElement.className = 'cart__decrease__quantity text-sm cursor-pointer'
      cartUtilsDecreaseElement.setAttribute('data-id', item.variant_id)
      cartUtilsDecreaseElement.innerHTML = '-'
      cartUtilsDecreaseElement.addEventListener('click', e => changeCartQuantity(e, 'decrease', false))

      let cartUtilsIncreaseElement = document.createElement('div')
      cartUtilsIncreaseElement.className = 'cart__increase__quantity text-sm cursor-pointer'
      cartUtilsIncreaseElement.setAttribute('data-id', item.variant_id)
      cartUtilsIncreaseElement.innerHTML = '+'
      cartUtilsIncreaseElement.addEventListener('click', e => changeCartQuantity(e, 'increase', false))

      let cartUtilsQuanityElement = document.createElement('div')
      cartUtilsQuanityElement.className = 'text-sm'
      cartUtilsQuanityElement.setAttribute('id', `cart-item-${item.variant_id}`)
      cartUtilsQuanityElement.innerHTML = item.quantity

      let cartUtilsQuantityTriggersWrapper = document.createElement('div')
      cartUtilsQuantityTriggersWrapper.className =
        'mt-0 text-xs text-right flex justify-end space-x-2 cart-item-quantity-selector '
      cartUtilsQuantityTriggersWrapper.appendChild(cartUtilsDecreaseElement)
      cartUtilsQuantityTriggersWrapper.appendChild(cartUtilsQuanityElement)
      cartUtilsQuantityTriggersWrapper.appendChild(cartUtilsIncreaseElement)

      let cartUtilsQuanityWrapper = document.createElement('div')
      cartUtilsQuanityWrapper.className = 'cart-item-quantity mb-4 sm:mb-0 flex flex-col justify-end text-right'

      cartUtilsQuanityWrapper.appendChild(cartUtilsQuantityLabel)
      cartUtilsQuanityWrapper.appendChild(cartUtilsQuantityTriggersWrapper)

      //SEZIONE PREZZO

      let cartUtilsPriceWrapper = document.createElement('div')
      cartUtilsPriceWrapper.setAttribute('id', `cart-item-price-${item.variant_id}`)
      cartUtilsPriceWrapper.className = 'cart-item-price text-sm text-right'
      cartUtilsPriceWrapper.innerHTML = renderItemPrice(item.final_price, item.compare_at_price, item.quantity)

      cartUtilsWrapper.appendChild(cartUtilsIconsWrapper)
      cartUtilsWrapper.appendChild(cartUtilsQuanityWrapper)
      cartUtilsWrapper.appendChild(cartUtilsPriceWrapper)

      cartItemWrapper.appendChild(cartAnchorElement)
      cartItemWrapper.appendChild(cartInfoWrapper)
      cartItemWrapper.appendChild(cartUtilsWrapper)
      sideCartItemList.appendChild(cartItemWrapper)
    })
    if (cartItems.items.length > 0) {
      document.querySelector('.cart__articles__container').style.display = 'block'
      document.querySelector('.cart__empty__container').style.display = 'none'
    } else {
      document.querySelector('.cart__articles__container').style.display = 'none'
      document.querySelector('.cart__empty__container').style.display = 'block'
    }
  }
}

async function changeCartQuantity(e, mode, remove) {
  let cartItems = await fetch('/cart.js')
    .then(response => response.json())
    .then(data => data)

  const item = cartItems.items.filter(cartItem => +cartItem.variant_id === +e.target.getAttribute('data-id'))[0]

  let selectedItem = {
    cartItem: item,
  }

  let newQuantity = mode == 'increase' ? selectedItem.cartItem.quantity + 1 : selectedItem.cartItem.quantity - 1
  newQuantity = newQuantity < 0 ? 0 : newQuantity

  //AZZERO QUANTITA' SE ATTIVATO IL FLAG DI RIMOZIONE DAL CARRELLO
  newQuantity = remove ? 0 : newQuantity

  let changeOptions =
    '{"updates"  : {' + '"' + selectedItem.cartItem.id.toString() + '" : "' + newQuantity.toString() + '"}}'

  let fetchOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: changeOptions,
  }

  let changeResult = await fetch('/cart/update.js', fetchOptions)
    .then(response => response.json())
    .then(data => data)

  if (changeResult) {
    let changedItem = changeResult.items.find(item => item.variant_id == selectedItem.cartItem.id)

    if (remove && !changedItem) {
      let itemToRemove = document.getElementById(`sideCart-item-${e.target.getAttribute('data-id')}`)
      itemToRemove && itemToRemove.remove()
    } else {
      changedItem.compare_at_price = await getFullPrice(changedItem)
      document.getElementById(`cart-item-${changedItem.variant_id}`).innerHTML = changedItem.quantity
      document.getElementById(`cart-item-price-${changedItem.variant_id}`).innerHTML = renderItemPrice(
        changedItem.final_price,
        changedItem.compare_at_price,
        changedItem.quantity
      )
    }

    let cartItems = Array.from(document.querySelectorAll('.sideCart_item'))
    if (cartItems.length > 0) {
      document.querySelector('.cart__articles__container').style.display = 'block'
      document.querySelector('.cart__empty__container').style.display = 'none'
    } else {
      document.querySelector('.cart__articles__container').style.display = 'none'
      document.querySelector('.cart__empty__container').style.display = 'block'
    }

    Array.from(document.querySelectorAll('#cart-subtotal span, #cart-total span')).forEach(item => {
      item.innerHTML = Shopify.formatMoney(changeResult.total_price, shopCurrencySymbol + priceFormat)
    })
    let cartIcon = Array.from(document.querySelectorAll('.cartItems'))
    cartIcon.forEach(icon => {
      icon.innerHTML = changeResult.items.length
    })
  }
}

// async function wishlistManagement(e) {
//   let data = await fetch(`/products/${e.target.getAttribute('data-handle')}.js`)
//     .then(response => response.json())
//     .then(data => {
//       return data
//     })

//   if (data) {
//     let wishlist = localStorage.getItem('wpWishlistItems')
//     let variantToSave = data.variants.find(item => item.id == e.target.getAttribute('data-id'))
//     variantToSave = {
//       ...variantToSave,
//       product: { title: data.title, vendor: data.vendor, url: data.url },
//     }
//     if (!wishlist) {
//       wishlist = [variantToSave]
//     } else {
//       wishlist = JSON.parse(wishlist)
//       let isItemInWishlist = wishlist.find(item => item.id == variantToSave.id)

//       if (!isItemInWishlist) {
//         wishlist.push(variantToSave)

//         document.querySelectorAll(`img[data-id="${variantToSave.id}"]`).forEach(item => {
//           item.setAttribute(
//             'src',
//             'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addedToWishlist.svg?v=1625561332'
//           )
//         })
//       } else {
//         wishlist = wishlist.filter(item => item.id !== variantToSave.id)
//         document.querySelectorAll(`img[data-id="${variantToSave.id}"]`).forEach(item => {
//           item.setAttribute(
//             'src',
//             'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addToWishlist.svg?v=1625561332'
//           )
//         })
//       }
//     }
//     localStorage.setItem('wpWishlistItems', JSON.stringify(wishlist))
//   }
// }

const addCompareAtPrice = async cart => {
  await cart.items.forEach(item => {
    $.ajax({
      url: '/products/' + item.handle + '.js',
      dataType: 'json',
      async: false,
      success: product => {
        const variant = product.variants.filter(v => v.id === item.variant_id)
        item['compare_at_price'] = variant.length ? variant[0].compare_at_price : 0
      },
    })
  })

  return cart
}
